const KEY = "conecta_invite";

const CODE = /^[A-HJ-NP-Z2-9]{6}$/;
const norm = (c) => (typeof c === "string" ? c.trim().toUpperCase() : "");

// A propósito en localStorage: la liga debe sobrevivir a instalar la PWA. Solo se guarda el código (no es secreto).
export const saveInvite = (codigo) => { const c = norm(codigo); if (CODE.test(c)) localStorage.setItem(KEY, c); };
export const getInvite = () => {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  const c = norm(raw.startsWith("{") ? raw.match(/"codigo":"([^"]*)"/)?.[1] : raw);
  if (!CODE.test(c)) { localStorage.removeItem(KEY); return null; }
  if (raw !== c) localStorage.setItem(KEY, c);
  return { codigo: c };
};
export const clearInvite = () => localStorage.removeItem(KEY);

export const INVITE_TEMPLATE = (nombre, liga) =>
  `Hola${nombre ? ` ${nombre}` : ""}, estoy en CONECTA, una red privada solo por invitación para presentarnos contactos de confianza. Tengo pocos lugares y quiero que estés: ${liga}`;

export const waUrl = (phone, text) => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
